<p>painting-category-list works!</p>
